import './index.scss'

import { DEFAULT_LANGUAGE, IntlProvider } from '@lm/intl'
import flatten from 'flat'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { HelmetProvider } from 'react-helmet-async'
import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/integration/react'

import App from './App'
import locales from './locales'
import { persistor, store } from './state/store'

const locale = DEFAULT_LANGUAGE
const messages = locales[locale]

const rootElement = document.getElementById('root')

if (!rootElement) {
  throw new Error('Root element not found')
}

const root = createRoot(rootElement)

root.render(
  <StrictMode>
    <IntlProvider
      messages={flatten(messages)}
      locale={locale}
      defaultLocale={DEFAULT_LANGUAGE}
    >
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <HelmetProvider>
            <App />
          </HelmetProvider>
        </PersistGate>
      </Provider>
    </IntlProvider>
  </StrictMode>
)
